
import * as z from "zod";
import { validatePhoneNumber, validateEmail } from "@/utils/sanitization";

export const contactFormSchema = z.object({
  businessName: z.string()
    .min(2, "Business name is required and must be at least 2 characters")
    .max(100, "Business name must be less than 100 characters")
    .transform(val => val.trim()),
  contactName: z.string()
    .min(2, "Contact name is required and must be at least 2 characters")
    .max(100, "Contact name must be less than 100 characters")
    .transform(val => val.trim()),
  email: z.string()
    .min(1, "Email is required")
    .email("Please enter a valid email address")
    .refine(validateEmail, "Please enter a valid email address"),
  phone: z.string()
    .min(1, "Phone number is required")
    .refine(validatePhoneNumber, "Please enter a valid phone number"),
});

export type FormValues = z.infer<typeof contactFormSchema>;
